module.exports = __webpack_public_path__ + "static/media/ice_warning.1f909a21.svg";